var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"link-back"},[_c('router-link',{attrs:{"to":_vm.calendarPath}},[_vm._v(" Zurück zum Kalendar ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }